import type { FeedbackOptions, HostMetadata } from '../types';

/** Reads the host app's metadata; a throwing callback must not block the report. */
export function resolveMetadata(source: FeedbackOptions['metadata']): HostMetadata | undefined {
  try {
    const value = typeof source === 'function' ? source() : source;
    return value && Object.keys(value).length ? { ...value } : undefined;
  } catch (err) {
    console.warn('[feedback] metadata callback failed', err);
    return undefined;
  }
}

interface SentryLike {
  lastEventId?: () => string | undefined;
}

/**
 * The latest Sentry event of the host app, if it runs the Sentry browser SDK (v7 and later expose
 * `Sentry.lastEventId()` on the global when loaded from the CDN or attached to window).
 */
export function detectSentry(fromHost?: () => string | undefined): { eventId: string } | undefined {
  try {
    const sentry = (globalThis as { Sentry?: SentryLike }).Sentry;
    const eventId = fromHost ? fromHost() : sentry?.lastEventId?.();
    return eventId ? { eventId } : undefined;
  } catch {
    return undefined;
  }
}
